<template>
  <div>
    <component :is="componentType"></component>
  </div>
</template>

<script>
export default {
  components: {
    PcTouGe: () => import("./TouGePc.vue"), // PC端组件
    MobileTouGe: () => import("./Mobile/TouGeMobile.vue"), // 移动端组件
  },

  computed: {
    componentType() {
      return this.$store.state.isMobile ? "MobileTouGe" : "PcTouGe";
    },
  },
};
</script>

<style scoped></style>
